import React from "react";
import { Button, Icon } from "atomize";

// Find Button
export const FindButton = () => {
  return <button className="button1">Find</button>;
};

// Oreder Button
export const OrderButton = () => {
  return <button className="button1">Order</button>;
};

// Next button
export const NextButton = () => {
  return (
    <Button
      h="2.5rem"
      w="2.5rem"
      bg="#FCB72B"
      rounded="circle"
      m={{ r: "1rem" }}
      shadow="2"
      hoverShadow="4"
      p="1.5rem"
    >
      <Icon name="LongRight" size="35px" color="#233348" />
    </Button>
  );
};

// Previous Button
export const PreviousButton = () => {
  return (
    <Button
      h="2.5rem"
      w="2.5rem"
      bg="#FFE8B9"
      rounded="circle"
      m={{ r: "1rem" }}
      shadow="2"
      hoverShadow="4"
      p="1.5rem"
    >
      <Icon name="LongLeft" size="35px" color="#DAA53A" />
    </Button>
  );
};

// Previous Button
export const LearnMoreButton = () => {
  return (
    <Button
      border="1px solid"
      borderColor="#FCB72B"
      textColor="#FCB72B"
      bg="#fff"
      hoverTextColor="#fff"
      hoverBg="#FCB72B"
      p={{ x: "2rem" }}
      rounded="55px"
      w="200px"
      h="56px"
    >
      Learn more
    </Button>
  );
};
